<script setup>
defineEmits(['create-template', 'create-form-flow', 'create-spreadsheet-flow']);

const options = [
  {
    id: 'templateOption',
    icon: 'file-invoice',
    action: 'create-template',
  },
  {
    id: 'formFlowOption',
    icon: 'code-branch',
    action: 'create-form-flow',
  },
  {
    id: 'spreadsheetFlowOption',
    icon: 'table',
    action: 'create-spreadsheet-flow',
  },
];
</script>

<template>
  <div
    :class="$style.container"
    data-testid="startAutomationStep"
  >
    <div>
      <h4 :class="$style.title">
        {{ $t('automation.onboardingModal.startAutomationStep.title') }}
      </h4>
      <p :class="$style.stepDescription">
        {{ $t('automation.onboardingModal.startAutomationStep.description') }}
      </p>
    </div>
    <div
      :class="$style.list"
      data-testid="startAutomationStepList"
    >
      <XCard
        v-for="option in options"
        :key="option.id"
        :class="$style.card"
        padding="var(--space-small-x)"
      >
        <div :class="$style.titleWrapper">
          <XIcon
            icon-style="fal"
            :icon="option.icon"
            size="lg"
            fixed-width
            left
          />
          <span :class="$style.cardTitle">{{
            $t(`automation.onboardingModal.startAutomationStep.${option.id}`)
          }}</span>
        </div>
        <XLink
          icon="arrow-right"
          icon-position="right"
          no-padding
          :data-testid="`${option.id}Action`"
          @click="() => $emit(option.action)"
        >
          {{ $t('automation.onboardingModal.startAutomationStep.action') }}
        </XLink>
      </XCard>
    </div>
    <p :class="$style.stepDescription">
      {{ $t('automation.onboardingModal.startAutomationStep.helpButtonReminder') }}
    </p>
    <b>{{ $t('automation.onboardingModal.startAutomationStep.conclusion') }}</b>
  </div>
</template>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  padding: var(--space-small-xx);
  gap: var(--space-medium);

  .stepDescription {
    margin-bottom: 0;
  }
}

.title {
  margin-bottom: var(--space-small-xxx);
  font-weight: var(--font-weight-bold);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-small-x);

  .card {
    display: flex;
    justify-content: space-between;
    background-color: var(--color-neutral-50);

    .titleWrapper {
      display: flex;
      align-items: center;
    }

    .cardTitle {
      font-weight: var(--font-weight-medium);
    }
  }
}
</style>
